const E = {
  Search: 'Search',
  Clear: 'Clear',
  'Exact Match': 'Exact Match',
  'Search Type': 'Search Type',
  'Select Additional Samples': 'Select Additional Samples',
  'Template Name': 'Template Name',
  'Invoice Attention': 'Invoice Attention',
  'Submission Type': 'Submission Type',
  'Project #': 'Project #',
  'Report Attention': 'Report Attention',
  Client: 'Client',
  'Site Location / Site #': 'Site Location / Site #',
  'Created By': 'Created By',
  'Date Type': 'Date Type',
  'PO #': 'PO #',
  'Modified By': 'Modified By',
  From: 'From',
  To: 'To',

  'Your Sample ID': 'Your Sample ID',
  'Job #': 'Job #',
  'Sample #': 'Sample #',
  'eCOC #': 'eCOC #',
  Status: 'Status',
  'COC #': 'COC #',
  Attention: 'Attention',
  'Invoice #': 'Invoice #',

  'Order #': 'Order #',
  'Addition #': 'Addition #',
  'Ordered By': 'Ordered By',
  Waybill: 'Waybill',

  'Task Order #': 'Task Order #',
  'Invoiced From': 'Invoiced From',
  'Invoiced To': 'Invoiced To',

  'Jobs & Samples': 'Jobs & Samples',
  'eCOC Templates': 'eCOC Templates',
  Supplies: 'Supplies',
  Invoices: 'Invoices',

  'Select All': 'Select All',
  'Created Date': 'Created Date',
  'Modified Date': 'Modified Date',
  'Date Ordered': 'Date Ordered',
  'Date Shipped': 'Date Shipped',
  'Date Required': 'Date Required',
  'Balance Due': 'Balance Due',
  Paid: 'Paid',
  Entered: 'Entered',
  'In Progress': 'In Progress',
  'Ready To Report': 'Ready To Report',
  Completed: 'Completed',
  Cancelled: 'Cancelled',
  Draft: 'Draft',
  Editing: 'Editing',
  Importing: 'Importing',
  Submitted: 'Submitted',

  'Received Date': 'Received Date',
  'Sampling Date': 'Sampling Date',
  'Job Due Date': 'Job Due Date',
  'Submitted Date': 'Submitted Date',
  reviseYourFilter: 'Please revise your filter.',
  noInfoFoundOnSearch: 'No information was found during your Search.',
  'Additional Analysis Request': 'Additional Analysis Request',
  'Job Overview': 'Job Overview',
 };

const F = {
  reviseYourFilter: 'Veuillez réviser votre filtre.',
  noInfoFoundOnSearch: "Aucune information n'a été trouvée lors de votre recherche",
  Search: 'Recherche',
  Clear: 'Effacer',
  'Exact Match': 'Correspondance exacte ',
  'Search Type': 'Type de recherche',
  'Select Additional Samples': 'Sélectionner des échantillons supplémentaires',
  'Template Name': 'Nom du modèle',
  'Invoice Attention': 'Destinataire',
  'Submission Type': "Type d'envoi",
  'Project #': 'No de projet',
  'Report Attention': 'Envoyer le rapport à',
  Client: 'Client',
  'Site Location / Site #': 'Emplacement ou no de site',
  'Created By': 'Créé par',
  'Date Type': 'Type de date',
  'PO #': 'No de PO',
  'Modified By': 'Modifié par',
  From: 'De',
  To: 'À',

  'Your Sample ID': " Votre ID d'échantillon",
  'Job #': 'No de dossier',
  'Sample #': "No d'échantillon",
  'eCOC #': "No d'eCDR",
  Status: 'Statut',
  'COC #': 'No CDR',
  Attention: "À l'attention de",
  'Invoice #': 'No de facture',

  'Order #': 'No de commande',
  'Addition #': 'demande supplémentaire #',
  'Ordered By': 'Commandé par',
  Waybill: "Bordereau d'expédition",

  'Task Order #': "No d'engagement",
  'Invoiced From': 'Facture provenant de',
  'Invoiced To': 'Facture envoyée à',

  'Jobs & Samples': 'Dossiers et échantillons',
  'eCOC Templates': "Modèles d'eCDR",
  Supplies: 'Matériel',
  Invoices: 'Factures',

  'Select All': 'Sélectionner tout',
  'Created Date': 'Créé le',
  'Modified Date': 'Modifié le',
  'Date Ordered': 'Commandé le',
  'Date Shipped': 'Envoyé le',
  'Date Required': 'Requis pour le',
  'Balance Due': 'Solde dû',
  Paid: 'Payé',
  Entered: 'Entré',
  'In Progress': 'En cours',
  'Ready To Report': 'Prêt pour générer le rapport',
  Completed: 'Terminé',
  Cancelled: 'Annulé',
  Draft: 'Ébauche',
  Editing: 'Édition',
  Importing: 'Importation',
  Submitted: 'Envoyé',
  'Received Date': 'Reçu le',
  'Sampling Date': 'Échantillonné le',
  'Job Due Date': 'Échéance du dossier',
  'Submitted Date': 'Envoyé le',
  'Additional Analysis Request':
    'Formulaire de demande d’analyse supplémentaire',
  'Job Overview': 'Résumé du dossier',
};

export default { E, F };



// WEBPACK FOOTER //
// ./src/constants/translations/globalSearch.js